
import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ReviewForm from '@/components/ReviewForm';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const AddReview = () => {
  const [searchParams] = useSearchParams();
  const companyName = searchParams.get('company');
  const navigate = useNavigate();
  const { user } = useAuth();
  
  // Debug logging
  console.log("AddReview: Rendered with", { 
    companyName, 
    isLoggedIn: !!user,
    userEmail: user?.email
  });

  // If no company is specified, redirect to the search flow
  if (!companyName) {
    console.log("AddReview: No company specified, redirecting to search");
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1 pt-24 px-6 pb-16">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12 animate-fade-in">
              <h1 className="text-3xl font-bold text-redflags-dark mb-2">
                Find a Company to Review
              </h1>
              <p className="text-redflags-gray max-w-xl mx-auto mb-8">
                Search for the company you want to review.
              </p>
              <Button 
                onClick={() => navigate('/companies?action=share')}
                className="bg-redflags-red hover:bg-redflags-red/90 text-white"
              >
                Search Companies
              </Button>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1 pt-24 px-6 pb-16">
        <div className="max-w-7xl mx-auto">
          <div className="mb-6">
            <Button 
              variant="ghost" 
              onClick={() => navigate('/companies?action=share')}
              className="text-redflags-gray hover:text-redflags-dark flex items-center gap-1"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to company search
            </Button>
          </div>
          
          <div className="text-center mb-12 animate-fade-in">
            <h1 className="text-3xl font-bold text-redflags-dark mb-2">
              Share Your Experience at {companyName}
            </h1>
          </div>
          
          <ReviewForm initialCompany={companyName} />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default AddReview;
